import Cookies from "js-cookie";
import {ShoppingEntry} from "../models/ShoppingEntry";

export function getAllShoppingEntries() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/shopping';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    }).then(response => {
        return response.ok ? response.json() : [];
    });
}

export function saveShoppingList(shoppingList: ShoppingEntry[]) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/shopping';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(shoppingList)
    }).then(response => {
        return response.ok ? response.json() : [];
    });
}

export function addIngredientsToShoppingList(entries: ShoppingEntry[]) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/shopping/entries';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(entries)
    }).then(response => {
        return response.ok ? response.json() : Promise.reject();
    });
}

export function deleteShoppingListEntry(id: number) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/shopping/' + id;
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        },
    }).then(response => {
        if (!response.ok) return Promise.reject();
    });
}

export function setEntryChecked(id: number, checked: boolean): Promise<void> {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/shopping/' + id + '/check?checked=' + checked;
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}` },
    }).then(response => {
        if (!response.ok) return Promise.reject();
    });
}

export function subscribeToShoppingEvents(onEntry: (entry: import('../models/ShoppingEntry').ShoppingEntry) => void): () => void {
    const token: string | undefined = Cookies.get('token');
    const url: string = process.env.REACT_APP_BASE_PATH + '/shopping/events?token=' + (token ?? '');
    const eventSource = new EventSource(url);
    eventSource.addEventListener('checked', (event: MessageEvent) => {
        try {
            onEntry(JSON.parse(event.data));
        } catch (_) {}
    });
    return () => eventSource.close();
}